






































































import { Component, mixins } from '@niknevis/vue-modules'
import TableTabs from '@/modules/common/tes-table/components/shared/TableTabs.vue'
import BaseSelect from '@/modules/shared/components/shared/kit/BaseSelect.vue'

@Component({
  components: {
    BaseSelect
  }
})
export default class TableSelect extends mixins(TableTabs) {
}
